import { render, staticRenderFns } from "./EditRewardModal.vue?vue&type=template&id=2f31c1ca&scoped=true&"
import script from "./EditRewardModal.vue?vue&type=script&lang=js&"
export * from "./EditRewardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f31c1ca",
  null
  
)

export default component.exports